<template>
     <b-row class="flex-grow-1 p-4">
        <b-col>
            <b-row>
                <b-col>
                    <label class="form-label" for="fontsizeSelect">{{xi18n(i8nPrefix, 'Fontsize')}}</label>
                    <select
                        @change="changeFont($event)"
                        @focus="onFocus(xi18n(i8nPrefix, 'Fontsize'))"
                        id="fontsizeSelect">
                        <option v-for="option in fontSizeOptions" :key="option" :value="option" :selected="option === fontSizeSelected">{{option}}</option>
                    </select>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <label class="form-label" for="speakCheck">{{xi18n(i8nPrefix, 'speak')}}</label>
                    <input
                        type="checkbox"
                        @change="setSpeak($event)"
                        @focus="onFocus(xi18n(i8nPrefix, 'speak'))"
                        :checked="accessibilityOptions.speak"
                        id="speakCheck" />
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <label class="form-label" >{{xi18n(i8nPrefix, 'switchBaseLayer')}}</label>
                    <baselayer-toggler mode="select" />
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <label class="form-label" >{{xi18n(i8nPrefix, 'LegendOptions')}}</label>
                    <legend-panel mode="accessible" />
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
    import { mapMutations } from 'vuex';
    import BaselayerToggler from '../../buttons/BaselayerToggler.vue';
    import Legend from '../legend/Web.vue';


    export default {
        components: { 'baselayer-toggler': BaselayerToggler, 'legend-panel': Legend, },
        data() {
            return {
                fontSizeOptions: ['0.8em', '1em', '1.4em'],
                fontSizeSelectedValue: null,
                speakActivatedValue: null,
                i8nPrefix: 'accessibility'
            };
        },
        computed: {
            fontSizeSelected() {
                return this.fontSizeSelectedValue || this.accessibilityOptions?.fontSize;
            },
            accessibilityOptions() {
                return this.$store.state.accessibility?.options;
            }
        },
        methods: {
            ...mapMutations(['SET_ACCESSIBLE_OPTIONS']),
            changeFont(e) {
                this.SET_ACCESSIBLE_OPTIONS({ fontSize: e.target.value });
            },
            setSpeak() {
                const speak = !this.accessibilityOptions.speak;
                this.SET_ACCESSIBLE_OPTIONS({ speak });
            },
            onFocus(text) {
                this.$store.dispatch('say', { text });
            },
        }
    };
</script>

<style scoped lang="scss">
    .form-label {
        width: 20vw;
        display: inline-block;
    }
    input[type=checkbox] {
        width: 1em;
        height: 1em;
    }
</style>
